import { createGlobalStyle } from "styled-components";
const GlobalStyle = createGlobalStyle `
    html,
    body {
        padding: 0;
        margin: 0;
        font-family: "Basis Grotesque Pro", Arial, sans-serif;
    }

    * {
        box-sizing: border-box;
    }

    :not(input):not(textarea):not(button) {
        user-select: none;
    }

    button {
        color: inherit;
        font: inherit;
        margin: 0;
        background: transparent;
        border: none;
        border-color: transparent;
        outline: none;
        padding: 0;
        appearance: none;
    }

    :root {
        --sat: 0px;
        --sab: 0px;
    }

    @supports (padding-top: env(safe-area-inset-top)) {
        :root {
            --sat: env(safe-area-inset-top);
            --sab: env(safe-area-inset-bottom);
        }
    }
`;
export default GlobalStyle;
